import { render, staticRenderFns } from "./atlasaktarim.vue?vue&type=template&id=55554c22&"
import script from "./atlasaktarim.vue?vue&type=script&lang=js&"
export * from "./atlasaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports